import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['send',  'schedule', 'interval', 'day', 'name', 'subject', 'from', 'fromPreview', 'subjectPreview', 'namePreview']

  initialize() {
    this.displaySchedule()
  }

  displaySchedule() {
    if (this.sendTarget.checked) {
      this.scheduleTarget.classList.remove("overlay")
    } else {
      this.scheduleTarget.classList.add("overlay")
    }
  }

  displayScheduleDay() {
    // both vocabularies until P5: Bootstrap surfaces use d-none, civic uses hidden
    if (this.intervalTarget.value == "monthly") {
      this.dayTarget.classList.remove("d-none", "hidden")
    } else {
      this.dayTarget.classList.add("d-none", "hidden")
    }
  }

  updateFrom() {
    this.fromPreviewTarget.innerText = this.fromTarget.value;
  }

  updateName() {
    this.namePreviewTarget.innerText = this.nameTarget.value;
  }

  updateSubject() {
    this.subjectPreviewTarget.innerText = this.subjectTarget.value;
  }

  updateCategory() {
    this.categoryTarget
  }
}
